module.exports = __webpack_public_path__ + "img/map.5b84c160.png";